<script lang="ts">
	import { page } from '$app/stores';
	import { Button } from '@atoms';
</script>

<svelte:head>
	<title>UPS | M.B.C.</title>
</svelte:head>

<section>
	<div class="container">
		<div class="inner">
			{#if $page.status === 404}
				<h1 class="text:headline-large">Siden blev ikke fundet.</h1>
				<p class="text:description-large">Vi kan desværre ikke finde siden, du leder efter.</p>
			{:else}
				<h1 class="text:headline-large">UPS! Denne side er i stykker.</h1>
				<p class="text:description-large">
					Hav venligst lidt tålmodighed med os. Vi gør vores bedste for at få siden til at spille
					igen.
				</p>
			{/if}
			<Button variant="primary" href="/" class="mt-8">Tilbage til forsiden</Button>
		</div>
		{#if $page.error?.errorId}
			<p class="text:description-small error-id">Fejl-ID: {$page.error.errorId}</p>
		{/if}
	</div>
</section>

<style lang="scss">
	section {
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		margin-top: 20px;
		margin-bottom: 20px;

		@include pagePadding;

		.error-id {
			padding: 20px;
		}

		h1 {
			padding-bottom: 32px;
		}

		p {
			padding-bottom: 50px;
			@include md {
				padding-bottom: 100px;
			}
		}

		.container {
			display: flex;
			flex-direction: column;
			background-color: hsl(var(--color-foreground));
			align-items: flex-end;
			color: hsl(var(--color-background));
			.inner {
				width: 100%;
				padding-top: 207px;
				padding-bottom: 207px;
				display: flex;
				flex-direction: column;
				text-align: center;
				align-items: center;
			}

			:global([data-button]) {
				color: hsl(var(--color-background));
				border: 1px solid hsl(var(--color-background));
			}
		}
	}
</style>
